import React from 'react';

const DownToBracket = () => {
  return (
    <div className="flex items-center">
      <img
        src={require('./downToBracket.png')}
        className="w-3.5 h-3.5 object-contain"
      />
    </div>
  );
};

export default DownToBracket;
